import React from "react";
import styled from "styled-components";
import LegacyPdm from "../../../../../assets/images/plmimplementationimage/MCADIntegrationimage/creo-logo.png";

const TIProEngineerOverview = () => {
  return (
    <AboutSectionWrapper>
      <Container className="container">
        <Row>
          {/* Content Column */}
          <ContentColumn>
            <InnerColumn>
              <SecTitle>
                <Title>PLM implementation / M-CAD Integration</Title>
                <Heading>Overview</Heading>
              </SecTitle>
              <Text>
                Teamcenter’s integration for Pro/Engineer enables all the design
                information created in Pro/Engineer to be captured, controlled,
                shared and managed by your organization in a single, highly
                secure CPDM environment. Using this integration, design teams
                can quickly search and access Pro/Engineer parts, drawings,
                assemblies & manufacturing data to eliminate time wasted trying
                to find and share design information, while reducing change
                orders by making certain that everyone is working from the
                latest design information and enabling design teams at different
                locations and through your supply chain to work closely together
                to streamline the product development process through multi-site
                collaboration. NexTech is helping customer to efficiently
                integrate pro-e, enable best practices to work in managed mode
                environment, to tune the performance and migrate legacy data.
              </Text>
            </InnerColumn>
          </ContentColumn>
          {/* Image Column */}
          <ImageColumn>
            <ImageInnerColumn data-wow-delay="0ms" data-wow-duration="1500ms">
              <ImageWrapper>
                <Image
                  src={LegacyPdm}
                  alt="Legacy PDM/PLM to Teamcenter Migration"
                />
                <ImageOverlayBox></ImageOverlayBox>
              </ImageWrapper>
            </ImageInnerColumn>
          </ImageColumn>
        </Row>
      </Container>
    </AboutSectionWrapper>
  );
};

export default TIProEngineerOverview;

const AboutSectionWrapper = styled.section`
  position: relative;
  padding: 20px 0px;
  font-family: "Poppins", system-ui;
`;

const Container = styled.div`
  .container;
`;

const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const ContentColumn = styled.div`
  flex: 1;
  position: relative;
  margin-bottom: 10px;
  @media (max-width: 992px) {
    padding-right: 0;
  }
`;

const InnerColumn = styled.div`
  position: relative;
  padding-top: 50px;
`;

const SecTitle = styled.div`
  position: relative;
  padding-bottom: 40px;
`;

const Title = styled.div`
  position: relative;
  color: #d7a449;
  font-size: 18px;
  font-weight: 700;
  padding-right: 50px;
  margin-bottom: 15px;
  display: inline-block;
  text-transform: capitalize;

  &:before {
    position: absolute;
    content: "";
    right: 0px;
    bottom: 7px;
    width: 40px;
    height: 1px;
    background-color: #bbbbbb;
  }
`;

const Heading = styled.h2`
  color: #252525;
`;

const Text = styled.div`
  font-family: "Jost", sans-serif;
  position: relative;
  color: #777777;
  font-size: 1em;
  line-height: 2em;
  margin-bottom: 40px;
  text-align: justify;
`;

const ImageColumn = styled.div`
  flex: 1;
  position: relative;
  margin-bottom: 50px;
`;

const ImageInnerColumn = styled.div`
  position: relative;
  padding: 40px 40px 0px 0px;
  margin-left: 50px;

  &:after {
    position: absolute;
    content: "";
    right: 27px;
    top: 5px;
    left: 40px;
    bottom: 64px;
    z-index: -1;
    border: px solid #d7a449;
  }
`;

const ImageWrapper = styled.div`
  position: relative;
`;

const ImageOverlayBox = styled.div`
  position: absolute;
  left: 40px;
  bottom: 48px;
`;

const Image = styled.img`
  position: relative;
  width: 90%; /* Adjust the width as needed */
  display: block;
  margin: 0 auto; /* Center the image */
`;
